import React from "react";
import { useQuery } from "@tanstack/react-query";
import { fetchCollection, queryKeys } from "@/src/services/reactQuery/reactQueryService";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { FormControl, ListSubheader, Stack } from "@mui/material";
import MessageCasePickerMenuItemContent from "./MessageCasePickerMenuItemContent";
import { splitUpByCompletedStatus } from "@/src/services/serviceWorldService";
import ProductBox from "@/src/components/ProductBox/ProductBox";

type MessagesCasePickerProps = {
  handleConversationClick: Function;
  selectedCase: any;
};

export default function MessagesCasePicker({ handleConversationClick, selectedCase }: MessagesCasePickerProps) {
  const { data: minimalCases, isLoading } = useQuery({
    queryKey: queryKeys.collection("/collection/cases"),
    queryFn: () => fetchCollection("/collection/cases"),
  });

  if (isLoading) {
    return null;
  }

  const { cases, closedCases } = splitUpByCompletedStatus(minimalCases);

  return (
    <ProductBox variant={"hintbox"} headline={"Fall auswählen"}>
      <Stack
        sx={{
          alignItems: "center",
        }}
      >
        <FormControl fullWidth={true} margin={"none"}>
          <Select value={selectedCase?.id || " "} aria-label={"Fall auswählen"}>
            {cases.map((minimalCase) => (
              <MenuItem key={minimalCase.id} onClick={() => handleConversationClick(minimalCase)} value={minimalCase.id}>
                <MessageCasePickerMenuItemContent minimalCase={minimalCase} />
              </MenuItem>
            ))}
            {closedCases.length > 0 && <ListSubheader>Abgeschlossen</ListSubheader>}
            {closedCases.map((minimalCase) => (
              <MenuItem key={minimalCase.id} onClick={() => handleConversationClick(minimalCase)} value={minimalCase.id}>
                <MessageCasePickerMenuItemContent minimalCase={minimalCase} />
              </MenuItem>
            ))}
            <MenuItem value={" "} disabled>
              {" "}
            </MenuItem>
          </Select>
        </FormControl>
      </Stack>
    </ProductBox>
  );
}
